'use client'

import type { ReportFalsyIdsOptions } from '@maestro/commerce-blocks/utils/utils.types'
import type { Product, ProductVariant } from '@maestro/data-layer'

import { reportDiagnostic } from '@maestro/commerce-blocks/client/api/diagnostics'

const reported = new Set<string>()

export function reportFalsyIds(props: ReportFalsyIdsOptions): void {
  const { hookName, listingType, rawIds, productContext } = props
  if (typeof window === 'undefined') {
    return
  }

  const filteredIds = rawIds.filter(Boolean)
  if (filteredIds.length === rawIds.length) {
    return
  }

  const pathname = window.location.pathname
  const key = `${hookName}:${pathname}:${filteredIds.join(',')}`

  if (reported.has(key)) {
    return
  }
  reported.add(key)

  const removedCount = rawIds.length - filteredIds.length

  void reportDiagnostic({
    level: 'error',
    message: 'Falsy product IDs filtered out',
    context: {
      hookName,
      listingType,
      rawIds,
      removedCount,
      pathname,
      ...productContext,
    },
  }).catch(() => {})
}

export function buildManyProductsContext(products: Product[]) {
  return {
    productCount: products.length,
    products: products.map((p) => ({ id: p.id, name: p.name, sku: p.sku })),
  }
}

export function buildSingleProductContext(product: Product) {
  return {
    productId: product.id,
    productName: product.name,
    sku: product.sku,
    variantCount: product.variants?.length,
    variants: (product.variants ?? []).map((v: ProductVariant) => ({
      id: v.id,
      sku: v.sku,
    })),
  }
}
